<template>
  <div class="container">

    <div class="topBox">
      <h1>套餐管理</h1>
      <el-button type="primary" @click="onClickAddNewData()">添加套餐</el-button>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="imageList" label="图片" width="150">
        <template #default="{ row }">
          <div class="imgBox">
            <img v-if="row.imageList && row.imageList.length > 0" :src="row.imageList[0].url" alt="图片" />
            <span v-if="row.imageList">*{{ row.imageList.length }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="标题" width="300" />
      <el-table-column prop="price" label="价格" width="100">
        <template #default="{ row }">
          ¥{{ row.price }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="200" />

      <el-table-column fixed="right" label="操作" min-width="120">
        <template #default="{ row }">
          <el-button link type="primary" size="small" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button link type="danger" size="small" @click="handleShowDeleteDialog(row)">
            删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>



    <el-dialog v-model="dialogFormVisible" title="编辑套餐" width="800">
      <el-form :model="currentCarData" ref="ruleFormRef" :rules="rules">

        <el-row>
          <el-col :span="24">
            <el-form-item label="相关图片" prop="WeddingImages">
              <div class="avatar-container">
                <div class="avatar-box" v-for="(item, index) in imageArray" :key="item.id">
                  <el-image class="avatar" :src="item.url" fit="cover" />

                  <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage1(index)" />

                </div>

                <el-upload v-if="imageArray.length < 7" ref="upload" class="upload-demo" :limit="1"
                  :before-upload="beforeUpload" :show-file-list="false">

                  <div class="avatar-box">
                    <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                  </div>

                </el-upload>


              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="维语套餐名称" prop="name">
              <el-input v-model="currentCarData.name" autocomplete="off" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="中文套餐名称" prop="nameZh">
              <el-input v-model="currentCarData.nameZh" autocomplete="off" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="套餐价格" prop="price">
              <el-input v-model="currentCarData.price" type="number" min="0" required></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">

          <el-col :span="16">
            <el-form-item label="形式" prop="type">
              <el-radio-group v-model="currentCarData.type">
                <el-radio :label="1">可租</el-radio>
                <el-radio :label="2">可售</el-radio>
                <el-radio :label="3">可租可售</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col class="dialog-el" :span="8">
            <el-form-item label="主纱数量" prop="mainWeddingDressNum">
              <el-select v-model="currentCarData.mainWeddingDressNum" placeholder="请选择">
                <el-option v-for="num in Array.from({ length: 10 }, (_, index) => index)" :key="num" :label="num"
                  :value="num">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col class="dialog-el" :span="8">
            <el-form-item label="晚礼服数量" prop="eveningDress">
              <el-select v-model="currentCarData.eveningDress" placeholder="请选择">
                <el-option v-for="num in Array.from({ length: 10 }, (_, index) => index)" :key="num" :label="num"
                  :value="num">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="女士民族风数量" prop="minorityNum">
              <el-select v-model="currentCarData.minorityNum" placeholder="请选择">
                <el-option v-for="num in Array.from({ length: 10 }, (_, index) => index)" :key="num" :label="num"
                  :value="num">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="伴娘服数量" prop="bridesmaidDressNum">
              <el-select v-model="currentCarData.bridesmaidDressNum" placeholder="请选择">
                <el-option v-for="num in Array.from({ length: 10 }, (_, index) => index)" :key="num" :label="num"
                  :value="num">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>




        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="西装数量" prop="manSuitNum">
              <el-select v-model="currentCarData.manSuitNum" placeholder="请选择">
                <el-option v-for="num in Array.from({ length: 10 }, (_, index) => index)" :key="num" :label="num"
                  :value="num">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="男士民族风数量" prop="manEthnicStyleNum">
              <el-select v-model="currentCarData.manEthnicStyleNum" placeholder="请选择">
                <el-option v-for="num in Array.from({ length: 10 }, (_, index) => index)" :key="num" :label="num"
                  :value="num">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="dialog-el" :span="8">
            <el-form-item label="伴郎服数量" prop="groomsmanUniformNum">
              <el-select v-model="currentCarData.groomsmanUniformNum" placeholder="请选择">
                <el-option v-for="num in Array.from({ length: 10 }, (_, index) => index)" :key="num" :label="num"
                  :value="num">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="success" @click="dialogMuBan = true">查看实例模板</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onClickAddData(ruleFormRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogVisible" title="提示" width="300" :before-close="handleClose">
      <span>删除后无法恢复，确定要删除么？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelete()">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogMuBan" title="乐队套餐模板" width="600">

      <el-row :gutter="20">
        <el-col :span="12">
          <h4>参考模板</h4>

          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">

            <el-carousel height="250px">
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://img2.baidu.com/it/u=2886931210,1861229790&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1200"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://qcloud.dpfile.com/pc/b9XjoHBqBV7NdPGsHAdBkg2yN9tl0Uw_2QRWJjSG7kDPiciHswFYVulDuj-3DiqZ.jpg"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://qcloud.dpfile.com/pc/gDxM90Ebb4Huc2l4O4RGv9w6cPqGy4jN4gwjBsDQFskLny8PcuWNnkiBsh18aMLo.jpg"
                  fit="cover" />
              </el-carousel-item>
            </el-carousel>
          </div>

        </el-col>
        <el-col :span="12">
          <h4>您编辑的</h4>
          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">
            <el-carousel height="250px">
              <el-carousel-item v-for="(image, index) in currentCarData.imageList" :key="index">
                <el-image style="width: 100%; height: 250px" :src="image.url" fit="cover" />
              </el-carousel-item>
            </el-carousel>


          </div>

        </el-col>
      </el-row>

    </el-dialog>

  </div>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { get, upload, post } from '@/api/http';
import { useStore } from 'vuex';


export default {
  name: 'PhotosPage',
  setup() {
    const store = useStore();

    const tableData = ref([]);
    const currentCarData = ref(null);
    const dialogFormVisible = ref(false);
    const imageArray = ref([]);
    const ruleFormRef = ref(null)

    const dialogVisible = ref(false);

    const dialogMuBan = ref(false);


    const shopId = computed(() => {
      const shop = store.state.shop;
      return shop ? shop.id : '';
    });

    // 表单验证规则
    const rules = reactive({
      WeddingImages: [
        {
          validator: (rule, value, callback) => {

            if (imageArray.value.length <= 0) {
              callback(new Error('图片不能为空'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],

      name: [{ required: true, message: '请输入维语名称', trigger: 'blur' }],
      nameZh: [{ required: true, message: '请输入中文名称', trigger: 'blur' }],
      price: [{ required: true, message: '请输入价格', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      type: [{ required: true, message: '请选择形式', trigger: 'change' }],
      mainWeddingDressNum: [{ required: true, message: '请选择主婚纱数量', trigger: 'change' }],
      eveningDress: [{ required: true, message: '请选择晚礼服数量', trigger: 'change' }],
      minorityNum: [{ required: true, message: '请选择民族风数量', trigger: 'change' }],
      bridesmaidDressNum: [{ required: true, message: '请选择伴娘服数量', trigger: 'change' }],
      manSuitNum: [{ required: true, message: '请选择西装数量', trigger: 'change' }],
      manEthnicStyleNum: [{ required: true, message: '请选择男士民族风数量', trigger: 'change' }],
      groomsmanUniformNum: [{ required: true, message: '请选择伴郎服数量', trigger: 'change' }],

    });


    onMounted(() => {
      getData();
    });


    const getData = async () => {
      try {
        const response = await get('adminWeddingDress/allShopDress', { "shopId": shopId.value })
        if (response.code === 200) {
          tableData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const addData = async () => {

      const dataParam = {
        'price': currentCarData.value.price,
        'name': currentCarData.value.name,
        'nameZh': currentCarData.value.nameZh,
        'type': currentCarData.value.type,
        'mainWeddingDressNum': currentCarData.value.mainWeddingDressNum,
        'eveningDress': currentCarData.value.eveningDress,
        'minorityNum': currentCarData.value.minorityNum,
        'bridesmaidDressNum': currentCarData.value.bridesmaidDressNum,
        'manSuitNum': currentCarData.value.manSuitNum,
        'manEthnicStyleNum': currentCarData.value.manEthnicStyleNum,
        'groomsmanUniformNum': currentCarData.value.groomsmanUniformNum,
        'imagesId': currentCarData.value.imagesId,
        'shopId': shopId.value,
        'status': currentCarData.value.status,
      };

      if (currentCarData.value.id) {
        dataParam.id = currentCarData.value.id;
      }


      try {
        const response = await post('adminWeddingDress/addDress', dataParam)
        if (response.code === 200) {
          dialogFormVisible.value = false;
          ElMessage.success("保存成功");
          getData();
        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }


    }



    const uploadFile = async (file) => {
      await upload('adminUpload/image', file, { 'type': 21 })
        .then(response => {

          if (response.code == 200) {

            imageArray.value.push(response.data);
            currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');

          } else {
            ElMessage.error('上传失败，请重试')
          }

        })
        .catch(error => {
          console.error('请求失败', error)
          ElMessage.error('请求失败，请重试')
        });
    }

    const deleteData = async (id) => {
      await get('adminResourse/deleteResourse/' + id)
        .then(() => {
          ElMessage.success("删除成功");
          dialogVisible.value = false;

        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const beforeUpload = (file) => {

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file);
      return false; // 阻止默认上传行为
    }

    const deleteDressData = async (id) => {
      await get('adminWeddingDress/deleteDress/' + id)
        .then(() => {
          ElMessage.success("删除成功");
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const handleEdit = (item) => {
      // 打印或处理编辑数据
      currentCarData.value = item;
      imageArray.value = item.imageList;
      dialogFormVisible.value = true;
    };

    const onClickAddNewData = () => {

      currentCarData.value = {};
      imageArray.value = [];
      dialogFormVisible.value = true;


    }

    const onClickAddData = async (formEl) => {
      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const removeImage1 = (index) => {
      if (imageArray.value[index] && imageArray.value[index].id) {
        deleteData(imageArray.value[index].id);
        imageArray.value.splice(index, 1);
        currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }

    const handleShowDeleteDialog = (row) => {
      currentCarData.value = JSON.parse(JSON.stringify(row));
      dialogVisible.value = true;
    }

    const handleDelete = () => {
      deleteDressData(currentCarData.value.id);
    }


    return {
      tableData,
      currentCarData,
      handleEdit,
      dialogFormVisible,
      imageArray,
      onClickAddData,
      onClickAddNewData,
      rules,
      ruleFormRef,
      removeImage1,
      beforeUpload,
      uploadFile,
      dialogVisible,
      handleShowDeleteDialog,
      handleDelete,
      dialogMuBan,

    }



  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.topBox {
  display: flex;
  justify-content: space-between;

}

.imgBox {
  display: flex;
  align-items: center;
}

.imgBox img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 10px;
}

.avatar-container {
  display: flex;
  flex-wrap: wrap;
}

.avatar-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;

}

.avatar-box:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10%;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: white;
}

.delete-icon:hover {
  color: #409EFF;
}

.uploader-icon {
  font-size: 25px;
  color: #8c939d;
  text-align: center;
  margin-top: 50%;
  transform: translate(0%, -50%);
}
</style>
